import React, { useState } from "react";
import { usePlayerStore } from "../store/store";
import './healthbar.css';

function ManaBar() {
    const mana = usePlayerStore((state) => state.mana);

    const [showPercentage, setShowPercentage] = useState(false);


    const [freeze, setFreeze] = useState(false);

    const percentage = ((100 * mana.current) / mana.max).toFixed(0);
    const width = percentage > 100 ? '100%' : (percentage < 0 ? '0%' : percentage + '%');

    const handleMouseExit = (e) => {
        freeze ? setShowPercentage(true) : setShowPercentage(false);
    }

    const handleMouseEnter = (e) => {
        freeze ? setShowPercentage(false) : setShowPercentage(true);
    }
    const handleFreeze = (e) => {
        setFreeze(!freeze);
    }

    return (
        <div className="vitials">
            <div className="mana-outer">
                <div className="mana-inner"
                    style={{ width: width }} >
                </div>
                <div className="health-info"
                    onMouseOver={handleMouseEnter}
                    onMouseOut={handleMouseExit}
                    onClick={handleFreeze}>
                    <p>Mana: {showPercentage ? percentage + '%' : mana.current + ' / ' + mana.max} </p>
                </div>
            </div>
        </div>
    );
}

export default ManaBar;